import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPricingPlans } from "../../services/apiV2";

export const fetchPricingPlans = createAsyncThunk(
  "pricingPlans/fetchPricingPlans",
  async (_, { rejectWithValue, signal }) => {
    try {
      const res = await getPricingPlans({ config: { signal } });
      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
